import { AbstractControl } from '@angular/forms';
import { ErrorMessage } from '../constants/error-message.constants';
import { Regex } from '../constants/regex.constants';
import { positiveNumberValidator, zeroOrGreaterNumberValidator } from './number.validator';

function createCurrencyValidator(disallowZero = false) {
    return (control: AbstractControl): { [key: string]: any } | null => {
        const isGreaterThanMin = disallowZero
            ? positiveNumberValidator(control)
            : zeroOrGreaterNumberValidator(control);
        if (isGreaterThanMin) {
            return isGreaterThanMin;
        }
        if (control.value !== '' && !Regex.Currency.test(control.value)) {
            return {
                currency: { message: ErrorMessage.currency }
            };
        }
        return null;
    };
}

export const currencyValidator = createCurrencyValidator();
export const currencyPositiveValidator = createCurrencyValidator(true);
